//Margin conventions
var margin = {top: 5, right: 28, bottom: 15, left: 102};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 420 - margin.top - margin.bottom;

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.scale.linear()
  .range([0,width]);

//Creates the yScale
var y0 = d3.scale.ordinal()
  .rangeBands([height, 0], 0)
  .domain(["India", "Sweden", "Denmark", "Germany", "Austria", "France", "Canada", "China", "United Kingdom", "Spain", "Australia", "Brazil", "Russia", "Rwanda", "United States"]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
  .scale(y0)
  .tickPadding(0)
  .orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
  .scale(xScale)
  .orient("bottom")
  .tickFormat(function(d) {return d; })
  .tickSize(height)
  .ticks(numTicks(width)); 

//Loads the data
d3.csv("data/incarcerationRate.csv", ready);

function ready(err, data) {

  if (err) throw "error loading data";

  //FORMAT data
  data.forEach(function(d) {
    d.rate = +d.rate;
  });

  //Sets the max for the xScale
  var maxX = d3.max(data, function(d) { return d.rate; });

  //Defines the xScale max
  xScale.domain([0, 700]);

  //Appends the y axis
  var yAxisGroup = svg.append("g")
    .attr("class", "y axis")
    .call(yAxis);

  //Binds the data to the bars      
  var categoryGroup = svg.selectAll(".g-category-group")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-category-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.country) + ")";
    });

  //Appends first bar   
  var bars = categoryGroup.append("rect")
    .attr("width", function(d) { return xScale(d.rate); })
    .attr("height", y0.rangeBand()/1.65 )
    .attr("class", "g-num")
    .attr("transform", "translate(0,4)")
    .classed("US-bar", function(d) { return d.country == "United States";});

  //Appends the x axis    
  var xAxisGroup = svg.append("g")
    .attr("class", "x axis")
    .call(xAxis);   
  
  //Binds data to labels
  var labelGroup = svg.selectAll("g-num")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g-label-group")
    .attr("transform", function(d) {
      return "translate(0," + y0(d.country) + ")";
    });

  //Appends first bar labels   
  var barLabels = labelGroup.append("text") 
    .text(function(d) {return  d.rate;})
    .attr("x", function(d) { return xScale(d.rate) +5; })
    .attr("y", y0.rangeBand()/1.65 )
    .attr("class", "g-labels");   
     
  //RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 5, right: 28, bottom: 15, left: 102};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth - newMargin.right]);

    //Update the bars
    bars
      .attr("width", function(d) { return xScale(d.rate); }); 

    //Updates bar labels
    barLabels
      .attr("x", function(d) { return xScale(d.rate) +5; })
      .attr("y", y0.rangeBand()/1.65 );

    //Updates xAxis
    xAxisGroup
      .call(xAxis);   

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(numTicks(newWidth));

  };

}

//Determines number of ticks base on width
function numTicks(widther) {
  if (widther <= 300) {
    return 4
    console.log("return 4")
  }
  else {
    return 6
    console.log("return 5")
  }
}